module.exports = {"version":"5.0.1"}


//////////////////
// WEBPACK FOOTER
// ./src/@package.js
// module id = 2
// module chunks = 0